import React from "react";
import { Link } from 'react-router-dom'
import himg from '../../images/Wilson Tamuka.png'


const Hero =() => {
    return (
        <section className="static-hero">
    <div className="hero-container">
        <div className="hero-inner">
            <div className="container">
                <div className="hero-text-wrap">
                    <div className="sub-title">
                        <span>A Full Legal Service Firm, Locally and Internationally.</span>
                    </div>
                    <div className="slide-title">
                        <h2>Where Elegance Meets Legal Innovation</h2>
                    </div>
                    <div className="slide-text">
                        <p>Wilson Tamuka Attorneys delivers high-quality, personalized legal services with precision, empathy, and strategic foresight. We combine technical excellence with emotional intelligence to ensure every client feels heard, protected, and empowered.</p>
                    </div>
                    <div className="clearfix"></div>
                    <div data-swiper-parallax="500" className="slide-btns">
                        <Link to="/about" className="theme-btn-s2">Explore Our Services</Link>
                    </div>
                </div>
                <div className="lawyer-pic">
                    <img src={himg} alt="Wilson Tamuka Mugaviri"/>
                    <div className="lawyer-shape"></div>
                    <div className="exprience">
                        <div className="exprience-left">
                            <h4>5+</h4>
                        </div>
                        <div className="exprience-right">
                            <h4>Years Of Legal Excellence</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    )
}



export default Hero;